module.exports = {"hello":"Merhaba!","language":"Dil"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/tr.json
// module id = 668
// module chunks = 1